<template>
  <div class="goods-detail my-container">
    <pageHeader title="商品详情" />

    <div class="gray-box"></div>

    <div class="account-info">
      <div class="box-title">
        <span>账号信息</span>
        <div class="underline-box"></div>
      </div>
      <div class="account-content">
        <img :src="accountInfo.logoUrl" alt="" />
        <div class="account-amount">
          <h1>{{ accountInfo.gameName }}</h1>
          <span class="account-desc">平台：{{ accountInfo.platName }}</span>

          <span class="total-sall">￥{{ accountInfo.sallPrice }}</span>
        </div>
      </div>

      <div class="account-game-info">
        <div class="game-info-cell">
          <div class="cell-label">
            <img src="@/assets/images/district-server-icon.png" alt="" />
            <span>区服</span>
          </div>
          <div class="cell-content">{{ accountInfo.gameAreaServer }}</div>
        </div>
        <div class="game-info-cell">
          <div class="cell-label">
            <img src="@/assets/images/role-name-icon.png" alt="" />
            <span>角色名</span>
          </div>
          <div class="cell-content">{{ accountInfo.roleName }}</div>
        </div>
        <div class="game-info-cell">
          <div class="cell-label">
            <img src="@/assets/images/cell-icon.png" alt="" />
            <span>累计消费</span>
          </div>
          <div class="cell-content">{{ accountInfo.totalMoney }}</div>
        </div>

        <img
          class="official-seal"
          src="@/assets/images/official-seal.png"
          alt=""
        />
      </div>
    </div>
    <div class="gray-box"></div>
    <div class="account-detail">
      <div class="box-title">
        <span>账号详情</span>
        <div class="underline-box"></div>
      </div>

      <div class="game-detail">
        <div class="game-desc">{{ accountInfo.title }}</div>
        <div class="game-img">
          <img
            @click="imgPreview(item)"
            v-for="item in gameImgUrl"
            :key="item"
            :src="item"
            alt=""
          />
        </div>
      </div>
    </div>

    <van-button @click="buySubmit" class="buy-submit">立即购买</van-button>

    <rechagePayWayPopup
      v-if="rechagePayWayPopupVisible"
      v-model="rechagePayWayPopupVisible"
      :payInfo="payInfo"
      @balancePayEvent="balancePayEvent"
    />

    <van-image-preview
      v-model="showImagePreview"
      :images="images"
      @change="onChange"
      closeable
      class="custom-preview"
    >
    </van-image-preview>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import rechagePayWayPopup from "@/components/RechagePayWayPopup";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
    rechagePayWayPopup,
  },
  computed: {
    ...mapGetters(["uuid"]),
    gameImgUrl() {
      if (this.accountInfo.imgUrl) {
        return this.accountInfo.imgUrl.split(";");
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      accountInfo: {},
      isdDisabled: false,
      rechagePayWayPopupVisible: false,
      payInfo: {},
      images: [],
      showImagePreview: false,
    };
  },
  mounted() {
    this.getTxAccDetail();
  },
  methods: {
    /**
     * 账号详情
     */
    async getTxAccDetail() {
      try {
        const { data } = await requestMethods(
          "/modules/accounttx/accountTx/getTxAccDetail.htm",
          "post",
          {
            accountTxId: this.$route.query.id,
            uuid: this.uuid,
          }
        );
        this.accountInfo = data;
      } catch (err) {
        this.$toast(err.message);
      }
    },

    buySubmit() {
      this.isdDisabled = true;
      this.payInfo = {
        uuid: this.uuid,
        accountTxId: this.accountInfo.id,
        apiUrl: "/modules/accounttx/accountBuy/applyBuyGameAccount.htm",
      };
      localStorage.setItem("payRouter", JSON.stringify("accountTrade"));
      this.rechagePayWayPopupVisible = true;
    },

    balancePayEvent() {
      this.$router.push({ path: "/tradeRecord", query: { pageTab: 1 } });
    },

    imgPreview(url) {
      this.showImagePreview = true;
      this.images = [...this.gameImgUrl];
    },

    getContainer() {
      return document.querySelector(".my-container");
    },
    onChange() {},
  },
};
</script>

<style lang="scss" scoped>
.goods-detail {
  .gray-box {
    width: 100%;
    height: 12px;
    background: #f7f8fa;
  }

  .account-info {
    padding: 18px 40px 30px 40px;

    .account-content {
      display: flex;
      align-items: flex-start;
      margin-top: 20px;
      img {
        width: 150px;
        height: 150px;
        margin-right: 20px;
      }

      .account-amount {
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #191919;
          margin-bottom: 5px;
          line-height: 45px;
          max-width: 478px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .account-desc {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #7f7f7f;
          line-height: 37px;
          margin-bottom: 18px;
          max-width: 520px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .total-sall {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #f44444;
          line-height: 45px;
        }
      }
    }

    .account-game-info {
      width: 670px;
      background: #fcfcfc;
      border-radius: 8px;
      border: 1px solid #b2b2b2;
      margin-top: 40px;
      position: relative;

      .official-seal {
        width: 235px;
        height: 191px;
        position: absolute;
        right: 15px;
        top: -60px;
      }

      .game-info-cell {
        display: flex;
        align-items: center;
        height: 70px;

        .cell-label {
          display: flex;
          align-items: center;
          width: 209px;
          height: 70px;
          padding-left: 19px;
          line-height: 70px;
          border-bottom: 1px solid #979797;

          img {
            width: 40px;
            height: 40px;
            margin-right: 16px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #191919;
            line-height: 37px;
          }
        }
        .cell-content {
          flex: 1;
          height: 70px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #4c4c4c;
          line-height: 70px;
          padding-left: 29px;
          border-bottom: 1px solid #979797;
          border-left: 1px solid #979797;
        }

        &:last-child {
          .cell-label,
          .cell-content {
            border-bottom: none;
          }
        }
      }
    }
  }

  .account-detail {
    padding: 18px 40px 148px 40px;

    .game-detail {
      margin-top: 20px;
      .game-desc {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #414141;
        line-height: 40px;
      }
      .game-img {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 10px;
        img {
          width: 210px;
          height: 210px;
          border-radius: 8px;
          margin-top: 10px;
        }
      }
    }
  }
  .box-title {
    width: 130px;
    text-align: center;
    position: relative;
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #222222;
      line-height: 45px;
      position: relative;
      z-index: 2;
    }
    .underline-box {
      position: absolute;
      left: 6px;
      top: 34px;
      width: 116px;
      height: 14px;
      background: linear-gradient(149deg, #ff957f 0%, #ffc8b2 99%);
      border-radius: 7px;
    }
  }

  .buy-submit {
    position: fixed;
    bottom: 60px;
    left: 24px;
    width: 702px;
    height: 88px;
    background: #ff7a3e;
    border-radius: 44px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #ffffff;
    line-height: 88px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/goodsDetail/index.vue